import axios from "../axios";

const endpoints = {
  getHandbook: (data) => axios.post("/handbook/joint", data),
  getStageHandbook: () => axios.get("/doc_stage")
};

export default endpoints;
